import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import styles from "./AnimatedNumber.module.css";

// カウントアップおよびカウントダウンのロジックをカプセル化するカスタムフック
function useCountUp(start, end, duration = 1000) {
  const [count, setCount] = useState(start);

  useEffect(() => {
    // 0が渡された場合は処理をスキップ
    if (end === 0) {
      setCount(0);
      return;
    }

    // 数値に変換（空文字の場合は0として扱う）
    const startNum = parseFloat(start);
    const endNum = parseFloat(end);

    // 目標値が現在値と同じなら何もしない
    if (startNum === endNum) return;

    // 1フレームあたりの変化量を計算
    const increment = (endNum - startNum) / (duration / 10);

    // タイマーを設定
    const timer = setInterval(() => {
      setCount((prevCount) => {
        const nextCount = parseFloat(prevCount) + increment;
        // カウントアップ
        if (increment > 0) return Math.min(nextCount, endNum);
        // カウントダウン
        return Math.max(nextCount, endNum);
      });
    }, 10);

    // クリーンアップ関数
    return () => clearInterval(timer);
  }, [start, end, duration]);

  return count;
}

// 数字が変わるとカウントアップまたはカウントダウンして表示されるコンポーネント
function AnimatedNumber({ number }) {
  const { t } = useTranslation();
  // 空文字が渡された場合の対応
  const targetNumber = number === "" ? "" : number;
  const animatedValue = useCountUp(0, targetNumber, 300);

  // 数値が空文字の場合は表示も空にする
  return (
    <div>
      <span className={styles.currency}>
        {animatedValue === "" ? "" : Math.round(animatedValue).toLocaleString()}
        <span className={styles.mark}>{t("円")}</span>
      </span>
    </div>
  );
}

export default AnimatedNumber;
